import React, { ReactNode } from 'react'
import Head from 'next/head'
import { Navbar } from '../Navbar'
import Footer from '../Footer'
import { DefaultHubColors, HubColors } from '../../interfaces'

type Props = {
  hubColors?: HubColors
  title?: string
  children?: ReactNode
}

const HubLayout = ({ title = 'KiwiTicket', children, hubColors = DefaultHubColors }: Props) => (
  <div className="flex flex-col" style={{ backgroundColor: hubColors.background }}>
    <Head>
      <title>{title} | KiwiTicket</title>
      <meta charSet="utf-8" />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />

      <meta name="theme-color" content={hubColors.primary}></meta>
      <meta name="msapplication-navbutton-color" content={hubColors.primary}></meta>
      <meta name="apple-mobile-web-app-capable" content="yes"></meta>
      <meta name="apple-mobile-web-app-status-bar-style" content={hubColors.primary}></meta>
    </Head>

    <header>
      <Navbar title={title} colorHex={hubColors.primary} />
    </header>

    <div className="self-center max-w-5xl text-white">
      {children}
    </div>

    <Footer />
  </div>
)

export default HubLayout
